import { render, staticRenderFns } from "./ControlBoxInspectionDetail.vue?vue&type=template&id=6f1f9afc&scoped=true"
import script from "./ControlBoxInspectionDetail.vue?vue&type=script&lang=js"
export * from "./ControlBoxInspectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f9afc",
  null
  
)

export default component.exports